import invariant from 'react-utils/invariant';
import { getIsPropertyOnlyToken } from 'rich-text-lib/utils/properties';
import { INSERT_PERSONALIZATION_TOKEN, EDIT_PERSONALIZATION_TOKEN } from '../constants/usageTracking';
import { trackInteraction } from '../utils/usageTracking';
import { createTokenString, getDefaultValueType } from './utils';
import { getHsDataTokenSettings } from './utils';
import { hsDataTokenConfig } from '../constants/hsdatatokens';
const getUndefined = () => undefined;
const getFilter = (editor, originalProperty = {}) => {
  const settings = getHsDataTokenSettings(editor);
  const propertyTypeFiltersCallBack = settings && settings[hsDataTokenConfig.PROPERTY_FILTERS_CALLBACK] || getUndefined;
  const filter = propertyTypeFiltersCallBack(originalProperty);
  invariant(['undefined', 'string'].includes(typeof filter), 'PROPERTY_FILTERS_CALLBACK must return a STRING');
  return filter;
};
export const getHandleUpdate = editor => function handleUpdate(fullToken, subProperty, defaultValue = '') {
  const {
    fieldType = '',
    category,
    name,
    originalProperty,
    isHubSpotDefined: isHubspotDefined
  } = fullToken;
  let path;
  if (getIsPropertyOnlyToken(category, name)) {
    path = name;
  } else {
    path = [category, name, subProperty].filter(part => part).join('.');
  }
  const filter = getFilter(editor, originalProperty);
  const textTokenNode = document.createTextNode(createTokenString({
    path,
    defaultValue,
    filter
  }));
  if (textTokenNode.textContent) {
    editor.insertContent(textTokenNode.textContent);
    trackInteraction(editor, 'tinymceEditPersonalizationToken', EDIT_PERSONALIZATION_TOKEN, {
      version: 'datatoken',
      tokenCategory: category,
      tokenName: name,
      isHubspotDefined,
      defaultValueType: getDefaultValueType(defaultValue),
      fieldType
    });
  }
};
export const getHandleInsert = editor => function handleInsert(fullToken, subProperty, defaultValue = '') {
  const {
    fieldType = '',
    category,
    name,
    originalProperty,
    isHubSpotDefined: isHubspotDefined
  } = fullToken;
  let path;
  if (getIsPropertyOnlyToken(category, name)) {
    path = name;
  } else {
    path = [category, name, subProperty].filter(part => part).join('.');
  }
  const filter = getFilter(editor, originalProperty);
  editor.insertContent(createTokenString({
    path,
    defaultValue,
    filter
  }));
  trackInteraction(editor, 'tinymceInsertPersonalizationToken', INSERT_PERSONALIZATION_TOKEN, {
    version: 'datatoken',
    tokenCategory: category,
    tokenName: name,
    isHubspotDefined,
    defaultValueType: getDefaultValueType(defaultValue),
    fieldType
  });
};
export const getInsertDataToken = editor => function insertDataToken({
  tokenPath,
  defaultValue,
  trackInteractionObj
}) {
  editor.insertContent(createTokenString({
    path: tokenPath,
    defaultValue
  }));
  trackInteraction(editor, 'tinymceInsertPersonalizationToken', INSERT_PERSONALIZATION_TOKEN, {
    version: 'datatoken',
    tokenCategory: trackInteractionObj.tokenCategory,
    tokenName: trackInteractionObj.tokenName,
    isHubspotDefined: trackInteractionObj.isHubspotDefined,
    defaultValueType: getDefaultValueType(defaultValue),
    fieldType: trackInteractionObj.fieldType
  });
};
export const getTokenRemoveHandler = editor => function handleTokenRemove(token) {
  editor.undoManager.transact(() => {
    editor.dom.remove(token);
  });
};